import { styled } from 'stitches.config'

export const Bar = styled('div', {
    width: '100%',
    height: '8px',
    background: '$primary-700',
    opacity: '0.25',

    variants: {
        filled: {
            true: {
                opacity: '1.0'
            }
        }
    }
})

export const ProgressBarRoot = styled('div', {
    display: 'flex',
    alignItems: 'center',
    gap: '$1',
    justifyContent: 'center',
    width: '100%',
})